export const gqlErrors = {
	forbidden: 'forbidden',
}
